module.exports = __webpack_public_path__ + "img/entrance_story_card1.c911d007.svg";